// extracted by mini-css-extract-plugin
module.exports = {"bookmarkButton":"_3XnX6aQgOY8F4dBsrytdry","label":"_18dHNbLRVBXDiTWB5OwAWk","activeButton":"_2i3TDRQazizRfm-A6i7P0s","inactiveButton":"_5ujhTfpPfsSwWmcJpPAou"};